/**
 * 직원 명부 개편(2026-09-13 · H) — **아직 서버에 없는 데이터**의 자리와 타입.
 *
 * 시안(web-design-style 샘플 `axi-employees-hr-list` · `axi-employees-hr-detail`)은 원본에 있는 카드·차트·탭을
 * 데이터가 없어도 **전부** 그린다(CLAUDE.md 「웹 화면 디자인 개편」). 화면은 지금 이 타입의 빈 값으로
 * 「데이터 준비 중」을 그리고, 서버가 붙으면 **같은 prop 에 값만 넣으면** 된다.
 *
 * 각 항목의 번호는 PR 본문 「후속 서버 요청 목록」 번호와 같다.
 */

/** ① 월별 재직 인원 — KPI 「재직 인원」 추이 선. 최근 6개월, 오래된 달이 앞. */
export interface HeadcountTrendPoint {
  /** `YYYY-MM` */
  month: string;
  active: number;
}

/** ② 계약 · 수습 만료 — KPI 「계약 · 수습 만료」. 오늘부터 30일 안. */
export interface ContractExpiryItem {
  userId: string;
  name: string;
  kind: 'CONTRACT' | 'PROBATION';
  /** `YYYY-MM-DD` */
  endsOn: string;
}

/** ③ 필수 인사정보 입력 집계 — KPI 「인사정보 입력」 · 상세 머리 「입력률」. */
export interface InputCompletionItem {
  key: string;
  label: string;
  missing: number;
}

/** ④ 예정 상태 — 목록 · 상세 배지. 지금 서버 상태(ACTIVE · LEAVE · RESIGNED)에 더해진다. */
export type PendingEmploymentState = 'JOIN_PENDING' | 'TRANSFER_PENDING' | 'LEAVE_PENDING' | 'RESIGN_PENDING';

/** ⑥ 직원 필드 — 인사정보 탭에서 지금 비어 있는 칸. */
export interface PersonExtraFields {
  gender: 'F' | 'M' | null;
  personalEmail: string | null;
  address: string | null;
  emergencyContact: string | null;
  managerName: string | null;
  duty: string | null;
  workplace: string | null;
}

/** ⑧ 인사기록 — 경력 · 학력 · 자격·어학 · 가족 · 발령 이력 탭. */
export interface CareerRow { company: string; role: string; period: string; recognized: string; verified: boolean }
export interface EducationRow { school: string; major: string; degree: string; period: string; status: string }
export interface CertRow { kind: 'CERT' | 'LANGUAGE'; name: string; issuer: string; acquiredOn: string; expiresOn: string | null }
export interface FamilyRow { relation: string; name: string; birthDate: string; dependent: boolean; note: string | null }
export interface AssignmentRow { title: string; effectiveOn: string; state: 'DONE' | 'SOON' }

/** 서버가 붙기 전 기본값 — `null` 은 «아직 서버에 없음», 빈 배열은 «있는데 0건» 으로 구분한다. */
export const NOT_READY = null;

export const EMPTY_EXTRA: PersonExtraFields = {
  gender: null, personalEmail: null, address: null, emergencyContact: null,
  managerName: null, duty: null, workplace: null,
};

/** 「데이터 준비 중」 한 줄 — 빈 상태 문구를 한 곳에서. */
export const NOT_READY_TEXT = '데이터 준비 중';
